import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "9",
      cy: "9",
      r: "9",
      fill: "#E1FFE4"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.5 8.88889L7.57317 12L13.5 6",
      stroke: "#22B02E",
      "stroke-width": "2"
    }, null, -1)
  ]))]))
}